




















































































































import { Component, Prop, Vue } from "vue-property-decorator";
import i18n from "@/i18n";
import { Route } from "vue-router";
import { AclMember } from "@/services/security/types";
import { CustomExtension, Param } from "@/services/customExtensions/types";
import {
    createExtension,
    getExtension,
    updateExtension,
    getAcl
} from "@/services/customExtensions/customExtensionService";
import HeaderActionButtons from "@/components/layouts/HeaderActionButtons.vue";
import UnsavedFormModal from "@/components/common/modals/UnsavedFormModal.vue";
import CustomExtensionAccess from "@/components/customExtensions/CustomExtensionAccess.vue";
import DirectFileUploadControl from "@/components/common/files/DirectFileUploadControl.vue";
import { customExtensionValidators } from "@/components/customExtensions/customExtensionValidators";
import { paramsFields } from "@/components/customExtensions/customExtensionFields";
import { validateForm } from "@/services/validation/validationService";
import validate from "@/directives/validate";
import { FolderEntites } from "@/services/folders/types";
import { FILEENDPOINT } from "@/app.config";
import { ValidationType } from "@/services/validation/types";

@Component<CustomExtensionForm>({
    beforeRouteLeave(to, from, next) {
        this.onBeforeRouteLeave(to, next);
    },
    components: { UnsavedFormModal, HeaderActionButtons, CustomExtensionAccess, DirectFileUploadControl },
    directives: {
        validate
    }
})
export default class CustomExtensionForm extends Vue {
    @Prop() customExtensionId!: string;

    // local state
    customExtension = {
        id: "",
        name: "",
        menuText: "",
        menuIconFileId: "",
        url: "",
        params: [] as Array<Param>,
        acl: [] as Array<AclMember>
    } as CustomExtension;

    priorCustomExtensionState = JSON.parse(JSON.stringify(this.customExtension)) as CustomExtension;

    acl = [] as AclMember[];
    localAcl = [] as AclMember[];
    i18n = i18n;
    validators = customExtensionValidators(this.customExtensionId ? this.customExtensionId : "");
    preventSave = false;
    preventBack = false;
    nextRoute = "";
    routeParams = {};
    saveClicked = false;
    continue = false;
    fetchingActive = false;
    fields = paramsFields;
    folders = FolderEntites;
    img = {
        width: 18,
        height: 18
    };

    // lifecycle hooks
    async created() {
        this.fetchData();
    }

    // methods
    fetchData() {
        if (this.customExtensionId || this.customExtension.id !== "") {
            this.fetchingActive = true;
            getExtension(this.customExtensionId ? this.customExtensionId : this.customExtension.id).then(response => {
                this.customExtension = response;
                this.priorCustomExtensionState = JSON.parse(JSON.stringify(this.customExtension)) as CustomExtension;
                this.fetchingActive = false;
            });
            getAcl(this.customExtensionId ? this.customExtensionId : this.customExtension.id).then(response => {
                this.acl = response;
                this.localAcl = JSON.parse(JSON.stringify(this.acl));
            });
        }
    }

    async save(back: boolean) : Promise<any> {
        if (this.saveClicked) return;
        this.saveClicked = true;

        (this.$refs.AccessComponent as any).emitData();

        if (!await validateForm([this.validators])) {
            this.saveClicked = false;
            return;
        }
        this.customExtension.acl = this.acl.map(x => ({ id: x.id, type: x.type } as AclMember));

        // create or update
        if (this.customExtension.id !== "") {
            await updateExtension(this.customExtension);
            this.saveClicked = false;
            this.priorCustomExtensionState = JSON.parse(JSON.stringify(this.customExtension));
            this.localAcl = this.acl;
            if (back) {
                this.$router.push({
                    name: "customExtensions"
                });
            }
        } else {
            const id = await createExtension(this.customExtension);
            const nameRule = this.validators.name.rules.find(r => r.type === ValidationType.UniqueExtensionName);
            if (nameRule) {
                nameRule.entityId = id;
            }
            this.saveClicked = false;
            this.customExtension.id = id;
            this.localAcl = this.acl;
            this.priorCustomExtensionState = JSON.parse(JSON.stringify(this.customExtension));
            if (back) {
                this.$router.push({
                    name: "customExtensions"
                });
            }
        }
    }

    back() {
        this.$router.push({
            name: "customExtensions"
        });
    }

    onContinue(data: boolean) {
        this.continue = data;
        if (data) this.$router.push({ name: this.nextRoute, params: this.routeParams });
        this.nextRoute = "";
    }

    addParam() {
        const param = { key: "", value: "" } as Param;
        this.customExtension.params.push(param);
    }

    removeButton(key: string) {
        const item = this.customExtension.params.find(x => x.key === key);
        if (!item) {
            return;
        }
        this.customExtension.params.splice(this.customExtension.params.indexOf(item), 1);
    }

    onToggleHeaderButtons(state: boolean) {
        this.preventSave = !state;
        this.preventBack = !state;
    }

    onfileUploaded(file: any) {
        this.$set(this.customExtension, "menuIconFileId", file.fileId);
        this.$set(this.customExtension, "menuIconName", file.originalFileName);
        this.loadImage();
    }

    removeImage() {
        this.customExtension.menuIconFileId = "";
        this.customExtension.menuIconName = "";
    }

    loadImage() {
        const image = new Image();
        image.src = this.imageUrl;
    }

    onAccessUpdated(data: AclMember[]) {
        this.acl = data;
    }

    // computed
    get imageUrl(): string {
        return `${FILEENDPOINT}${this.customExtension.menuIconFileId}`;
    }

    get editMode() {
        return !!this.customExtension.id;
    }

    // router events
    async onBeforeRouteLeave(to: Route, next: any) {
        if (this.saveClicked || this.continue || this.fetchingActive) {
            next();
        } else {
            (this.$refs.AccessComponent as any).emitData();
            this.nextRoute = to.name ? to.name : "";
            this.routeParams = to.params;
            const noChanges = this.lodash.isEqual(this.priorCustomExtensionState, this.customExtension) && this.lodash.isEqual(this.localAcl, this.acl);
            if (noChanges) {
                next();
            } else {
                next(false);
                (this.$refs.UnsavedFormModal as any).open();
            }
        }
    }
}
